import { ApolloClient, gql } from 'apollo-boost';

const surveyAnswerQuery = gql`
  mutation reportSurveyAnswer(
    $id: Int
    $originalQuestionText: String
    $value: String
    $questionId: Int
    $npoId: Int
    $reportId: Int
    $optionId: Int
  ) {
    reportSurveyAnswer(
      id: $id
      originalQuestionText: $originalQuestionText
      value: $value
      questionId: $questionId
      npoId: $npoId
      reportId: $reportId
      optionId: $optionId
    ) {
      id
      success
    }
  }
`;

export const saveSurveyAnswer = (
  client: ApolloClient<object>,
  variables: {
    id: number | string | undefined;
    originalQuestionText: string;
    value: string;
    questionId: number | string;
    npoId: number | string;
    reportId: number | string;
    optionId?: number | string;
  },
) => {
  return client.mutate({
    mutation: surveyAnswerQuery,
    variables,
    fetchPolicy: 'no-cache',
  });
};
